module.exports = __webpack_public_path__ + "static/media/horario.370dcb81.jpg";